// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MainTemplate_wrapper_33_Oq","contentWrapper":"MainTemplate_contentWrapper_2kraD","content":"MainTemplate_content_1aVf6","isDark":"MainTemplate_isDark_20GHe"};